import { apiClient } from './apiClient';

export interface BillingPlan {
  code: string;
  display_name: string;
  price: number;
  monthly_equivalent: number;
  includes_portalr: boolean;
  recommended: boolean;
  feature_summary: string[];
  billing_interval: 'monthly' | 'yearly';
}

export interface BillingPlansResponse {
  launchpoint: { monthly: BillingPlan[]; yearly: BillingPlan[] };
  growth_stack: { monthly: BillingPlan[]; yearly: BillingPlan[] };
}

export interface BillingCurrentResponse {
  plan_code: string;
  billing_interval: 'monthly' | 'yearly';
  renewal_date: string | null;
  includes_portalr: boolean;
  feature_summary: string[];
  status: string;
}

class BillingService {
  async getPlans(): Promise<BillingPlansResponse> {
    return apiClient.get('/billing/plans/');
  }

  async getCurrent(): Promise<BillingCurrentResponse> {
    return apiClient.get('/billing/current/');
  }

  async upgrade(targetPlanCode: string): Promise<
    | { message: string; subscription: any }
    | { checkout_url: string; session_id: string; message: string }
  > {
    return apiClient.post('/billing/upgrade/', { target_plan_code: targetPlanCode });
  }
}

export const billingService = new BillingService();
